








































import Vue from 'vue';

export default Vue.extend({
  name: 'RightSlidePopup',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
  },

  watch: {
    show() {
      this.isShow = this.show;
    },
  },

  methods: {
    open() {
      let resolve, reject;
      const popupPromise = new Promise((ok, fail) => {
        resolve = ok;
        reject = fail;
      });

      this.currentPopupController = { resolve, reject };
      this.isShow = true;

      return popupPromise;
    },
    confirm() {
      if (this.currentPopupController) {
        this.currentPopupController.resolve();
      }
      this.isShow = false;
    },
    close() {
      this.isShow = false;
      this.$emit('hide');
    },
  },

  data() {
    return {
      isShow: this.show,
      currentPopupController: null as any,
    };
  },
});
